import React from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import styles from "./validation-check.module.scss";

type ValidationCheckAgentProps = {
  parsedContent: any;
};

export default function ValidationCheckAgent({
  parsedContent,
}: ValidationCheckAgentProps): JSX.Element {
  const { answer, question } = parsedContent;

  // Parse the answer JSON to extract warnings
  let warnings: string[] = [];

  try {
    const answerData = typeof answer === "string" ? JSON.parse(answer) : answer;
    warnings = answerData.warnings || [];
  } catch (e) {
    console.error("Failed to parse validation warnings:", e);
    warnings = [answer]; // Fallback to raw answer
  }

  return (
    <div className={styles.validationContainer}>
      <div className={styles.warningHeader}>
        <svg
          className={styles.warningIcon}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2L2 20h20L12 2zm0 14.5h0.01M12 10v4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <h3 className={styles.warningTitle}>Experience Mismatch</h3>
      </div>

      <div className={styles.warningList}>
        {warnings.map((warning, idx) => (
          <div key={idx} className={styles.warningItem}>
            <div className={styles.warningBullet}>⚠️</div>
            <div className={styles.warningText}>
              <MarkdownRenderer content={warning} />
            </div>
          </div>
        ))}
      </div>

      {question && (
        <div className={styles.warningPrompt}>
          <MarkdownRenderer content={question} />
        </div>
      )}
    </div>
  );
}
